import React, { useState } from "react";
import { GenericDiv, Label, PopupForm, TextArea } from "../common/Style";
import { sendWelcome } from "../../store/reducers/efratReducer";
import { toast } from "react-toastify";
import { getImageUrl, parseIsoDate } from "../common/others/Functions";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

const WelcomeMsg = ({ user, init, selfInit }) => {
  const dispatch = useDispatch();
  const [tempMsg, setTempMsg] = useState(
    `שמענו שמגיע לכם מזל טוב :) 
ברוכים הבאים למשפחת סופיה, מצרפים לכם צ׳אקליסט שיוכל לעזור בצעדים הבאים..
נפגש ביום הגדול 🥹🤍
\n\n
https://l5k.me/TdMyg`
  );

  const {
    formState: { errors },
  } = useForm();

  const handleSendMsg = async () => {
    const body = {
      Recipients: [{ msg: tempMsg, Phone: user.bridePhone }],
    };
    dispatch(sendWelcome(body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        selfInit();
        init();
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      className="animate__animated animate__fadeIn"
      style={{ position: "relative" }}
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
          marginTop: "40px",
        }}
      >
        <Label>תוכן ההודעה</Label>
        <TextArea
          defaultValue={tempMsg}
          onChange={(e) => setTempMsg(e.target.value)}
          type="text"
          rows="5"
        />
        <GenericDiv
          onClick={handleSendMsg}
          style={{ width: "100%", marginTop: "30px" }}
        >
          שליחה
        </GenericDiv>
      </div>
    </PopupForm>
  );
};

export default WelcomeMsg;
